import { Component, Input, OnInit } from '@angular/core';
import { ProgramService } from '../../../../services/aws/program/program.service';
import { ActivatedRoute } from '@angular/router';
import { take } from 'rxjs/operators';
import { ReportService } from 'src/app/services/aws/report/report.service';
import { IParticipant } from 'src/app/models/IParticipant';
import { IErrorMessage } from 'src/app/widgets/error-message/error-message.interface';
import { API_USER_DEFINED_MESSAGE } from 'src/app/widgets/error-message/error-message.const';

@Component({
    selector: 'program-registration',
    templateUrl: './registration.component.html',
    styleUrls: ['./registration.component.scss'],
    standalone: false
})
export class RegistrationComponent implements OnInit {

    @Input()
    parentSpinner: boolean;
    
    mode: string = 'view';
    searchmode: string = 'open';
    programId: any;
    participants: IParticipant[];
    public errorMessage: IErrorMessage = {};
    isDesc: boolean = false;
    column: string = 'lastName';
    direction: number = 1;
    isLastNameAsc: boolean = false;
    isEmailAsc: boolean = false;
    isHotelStatusAsc: boolean = false;
    isCourseStatusAsc: boolean = false;
    isFlightArrivalStatusAsc: boolean = false;
    isFlightDepartureStatusAsc: boolean = false;
    isInviteeStatusAsc : boolean = false;
    isRegistrationTypeAsc : boolean = false;
    programName: string;
    sDate: any;
    eDate: any;
    showLoading: boolean = false;
    public isDateSort: boolean = false;
    acceptedStatusCount: number;
    selectedFilter: string = 'all'; // Default filter
    allParticipants: IParticipant[];

    constructor(private programservice: ProgramService, private reportService: ReportService, private route: ActivatedRoute) {
        this.route.params.pipe(take(1)).subscribe(params => {
            this.programId = params["id"];
        });
    }

    ngOnInit() {
        this.getList();
    }

    public getList() {
        this.errorMessage = {};
        this.showLoading=this.parentSpinner;
        this.programservice.getParticipantsByProgram(this.programId)
        .subscribe((response: any) => {
            this.showLoading=false;
            this.errorMessage.text = response?.length? '' : API_USER_DEFINED_MESSAGE.EMPTY_RESPONSE;
            this.acceptedStatusCount = 0;
            response.forEach((participant: IParticipant) => {
                if (participant?.hotelStatus === 'Declined Room') {
                    participant.hotelStatus = 'Declined';
                }
                if (participant?.inviteeStatus === 'Accepted') {
                    this.acceptedStatusCount++;
                }
            });
            this.participants = response;
            this.allParticipants = response;
            this.onFilterChange();
            // this.sort('lastName');
            return response;
        },
        () => {
            this.showLoading=false;
            this.participants = [];
            this.allParticipants = [];
            this.errorMessage.text = API_USER_DEFINED_MESSAGE.FAILED;
        });

    }

    toggleRegistration() {
        this.mode = this.mode != 'edit' ? 'edit' : 'view';
        this.searchmode = this.searchmode != 'close' ? 'close' : 'open';
        if (this.mode == 'edit' && this.participants != undefined)
            this.participants= this.participants.filter(x => x.hotel != null && x.hotel.status != null && x.hotel.status.toUpperCase() == 'WAITLIST');
        else this.getList();
    }

    sort(property, event) {
        event.stopPropagation();
        this.isDesc = !this.isDesc;
        this.column = property;
        this.direction = this.isDesc ? 1 : -1;
        this.isDateSort = false;
        switch (property) {
            case 'lastName':
                this.isLastNameAsc = !this.isLastNameAsc;
                break;
            case 'email':
                this.isEmailAsc = !this.isEmailAsc;
                break;
            case 'hotelStatus':
                this.isHotelStatusAsc = !this.isHotelStatusAsc;
                break;
            case 'courseStatus':
                this.isCourseStatusAsc = !this.isCourseStatusAsc;
                break;
            case 'flightArrival':
                this.isFlightArrivalStatusAsc = !this.isFlightArrivalStatusAsc;
                this.isDateSort = true;
                break;
            case 'flightDeparture':
                this.isFlightDepartureStatusAsc = !this.isFlightDepartureStatusAsc;
                this.isDateSort = true;
                break;
            case 'inviteeStatus':
                this.isInviteeStatusAsc = !this.isInviteeStatusAsc;
                break;
            case 'registrationType':
                this.isRegistrationTypeAsc = !this.isRegistrationTypeAsc;
                break;
        }
    }

    download() {
        this.reportService.getRegistrationStatusReport(this.programId);
    }

    onFilterChange() {
        if (this.selectedFilter === 'accepted') {
            this.participants = this.participants?.filter(item => item?.inviteeStatus === 'Accepted');
            this.errorMessage.text = this.participants?.length? '' : API_USER_DEFINED_MESSAGE.EMPTY_ACCEPTED_STATUS;
        } else {
            this.participants = this.allParticipants;
        }
    }
}
